import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { AwButtonComponent } from '@components/misc/aw-button/aw-button.component';
import { AwModalComponent } from '@components/misc/aw-modal/aw-modal.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-introduction-modal',
    imports: [AwModalComponent, TranslateModule, AwButtonComponent],
    templateUrl: './introduction-modal.component.html',
    styleUrl: './introduction-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntroductionModalComponent {
    constructor(private readonly dialogRef: DialogRef<void>) {}

    close(): void {
        this.dialogRef.close();
    }

    getIconPathByIndex(index: number) {
        switch (index) {
            case 0:
                return 'assets/icons/nav-icons-black/home.svg';
            case 1:
                return 'assets/icons/nav-icons-black/transactions.svg';
            case 2:
                return 'assets/icons/nav-icons-black/locations.svg';
            case 3:
                return 'assets/icons/nav-icons-black/device.svg';
            case 4:
                return 'assets/icons/nav-icons-black/users.svg';
            default:
                return '';
        }
    }

    getIconAltTextByIndex(index: number) {
        switch (index) {
            case 0:
                return 'Home';
            case 1:
                return 'Transactions';
            case 2:
                return 'Locations';
            case 3:
                return 'Devices';
            case 4:
                return 'Users';
            default:
                return '';
        }
    }
}
